import { AdminAnalyticsService, OpenAPI } from '@/services';
import { request as apiRequest } from '@/services/general/core/request';
import type { CancelablePromise } from '@/services';

export type { PhoneCallDensityCell } from '@/services';
export type { PhoneCallAnalyticsPoint } from '@/services';
export type { PhoneCallDensityResponse } from '@/services';
export type { PhoneCallAnalyticsResponse } from '@/services';

export type PhoneCallStatus = 'connected' | 'no_answer' | 'voicemail' | string;

export type GetPhoneCallAnalyticsParams = {
  campaignId?: string;
  startedFrom?: string | null;
  startedTo?: string | null;
  durationMin?: number | null;
  durationMax?: number | null;
  callStatus?: string | null;
  limit?: number;
};

export const getPhoneCallAnalytics = ({
  campaignId,
  startedFrom,
  startedTo,
  durationMin,
  durationMax,
  callStatus,
  limit,
}: GetPhoneCallAnalyticsParams = {}) => {
  return AdminAnalyticsService.getPhoneCallAnalyticsAdminAnalyticsPhoneCallsGet(
    campaignId,
    startedFrom,
    startedTo,
    durationMin,
    durationMax,
    callStatus,
    limit
  );
};

export type GetPhoneCallDensityParams = {
  campaignId?: string;
  startedFrom?: string | null;
  startedTo?: string | null;
  granularity?: string | null;
};

export const getPhoneCallDensity = ({
  campaignId,
  startedFrom,
  startedTo,
  granularity,
}: GetPhoneCallDensityParams = {}) => {
  return AdminAnalyticsService.getPhoneCallDensityAdminAnalyticsPhoneCallsDensityGet(
    campaignId,
    startedFrom,
    startedTo,
    granularity
  );
};

/**
 * One aggregated events bin: platform events grouped by time bucket ×
 * event type × outcome. `outcome` is null for non-`call.ended` events.
 */
export type EventsAnalyticsBucket = {
  bucket_start: string;
  event_type: string;
  outcome: string | null;
  count: number;
};

export type EventsAnalyticsTotals = {
  total_events: number;
  total_calls: number;
  reply_calls: number;
  pickup_rate: number;
};

export type EventsAnalyticsResponse = {
  buckets: EventsAnalyticsBucket[];
  totals: EventsAnalyticsTotals;
  granularity: string;
};

export type GetEventsAnalyticsParams = {
  dateFrom: string;
  dateTo: string;
  campaignId?: string;
  eventTypes?: string[];
  granularity?: string;
};

// The events endpoint is not in the generated client yet; this mirrors what
// openapi-typescript-codegen would emit for GET /admin/analytics/events.
export const getEventsAnalytics = ({
  dateFrom,
  dateTo,
  campaignId,
  eventTypes,
  granularity,
}: GetEventsAnalyticsParams): CancelablePromise<EventsAnalyticsResponse> => {
  return apiRequest(OpenAPI, {
    method: 'GET',
    url: '/admin/analytics/events',
    query: {
      date_from: dateFrom,
      date_to: dateTo,
      campaign_id: campaignId,
      event_types: eventTypes,
      granularity,
    },
    errors: {
      422: `Validation Error`,
    },
  });
};
